import { render, staticRenderFns } from "./ReviewProject.vue?vue&type=template&id=2cee4102&"
import script from "./ReviewProject.vue?vue&type=script&lang=js&"
export * from "./ReviewProject.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports